import ModuleStarterCard from './ModuleStarterCard';
import { IModuleStarterCard } from '@/shared/types/platform-pages';
import { map } from 'lodash-es';
import './index.less';

interface IProps {
  title: { text: string; color: string };
  cards: IModuleStarterCard[];
}

const ModuleStarterCardsSection = ({ title, cards }: IProps) => {
  return (
    <div className="module-starter-cards-section">
      <div className="header">
        <div className="header-text">
          <span className="title" style={{ color: title.color }}>
            {title.text}
          </span>
        </div>
      </div>
      <div className="cards">
        {map(cards, (card: IModuleStarterCard, i: number) => (
          <ModuleStarterCard key={`card-${i}`} {...card} />
        ))}
      </div>
    </div>
  );
};

export default ModuleStarterCardsSection;
